module.exports = __webpack_public_path__ + "static/media/logo+name.db69cc4f.svg";